/**
 * Supported consumers configuration
 */

export const CONSUMER_WYNN = 'wynn' as const;
export const CONSUMER_WYNN_EBH = 'wynn_ebh' as const;
export const CONSUMER_MGM = 'mgm' as const;
export const CONSUMER_DISNEY_CRUISE = 'disney_cruise' as const;

export const SUPPORTED_CONSUMERS = [
  CONSUMER_WYNN,
  CONSUMER_WYNN_EBH,
  CONSUMER_MGM,
  CONSUMER_DISNEY_CRUISE,
] as const;

export type SupportedConsumer = typeof SUPPORTED_CONSUMERS[number];

/**
 * Check if a consumer name is supported
 */
export function isValidConsumer(consumer: string): consumer is SupportedConsumer {
  return SUPPORTED_CONSUMERS.includes(consumer as SupportedConsumer);
}

/**
 * Get a valid consumer, returning null if unknown (triggers default styling)
 */
export function getValidConsumer(consumer: string | undefined | null): SupportedConsumer | null {
  if (!consumer) return null;
  return isValidConsumer(consumer) ? consumer : null;
}
